var _rect, _path, _circle, _circle2, _circle3, _line, _line2, _line3, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 418,
    viewBox: "0 0 501 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 417.822,
    rx: 32,
    fill: "#A3CEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31C0 13.8792 13.8792 0 31 0H470C487.121 0 501 13.8792 501 31V86H0V31Z",
    fill: "#CEE5FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8.5,
    fill: "#1E5DEB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 43.5,
    r: 8.5,
    fill: "#1E5DEB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 43.5,
    r: 8.5,
    fill: "#1E5DEB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 169.5,
    x2: 500.004,
    y2: 169.5,
    stroke: "#CEE5FF",
    strokeDasharray: "4 4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 232.5,
    x2: 500.004,
    y2: 232.5,
    stroke: "#CEE5FF",
    strokeDasharray: "4 4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 295.5,
    x2: 500.004,
    y2: 295.5,
    stroke: "#CEE5FF",
    strokeDasharray: "4 4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 123,
    width: 416,
    height: 256,
    rx: 22,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.956 214.862H235.404V225.471H219.956V214.862Z",
    fill: "#1E5DEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.303 184.98V280.351",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 318.057H65.4819V320.95H51V318.057Z",
    fill: "#1E5DEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9424 288.505L58.0909 378",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.961 265.013H151.408V274.657H135.961V265.013Z",
    fill: "#1E5DEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.123 234.616V329.987",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M369.603 191.716H385.05V207.147H369.603V191.716Z",
    fill: "#1E5DEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M377.367 186.399V272.907",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.609 242.061H172.226V277.515H156.609V242.061Z",
    fill: "#1E5DEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.418 221.852V297.015",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.02 265.929H129.636V301.382H114.02V265.929Z",
    fill: "#1E5DEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.829 259.433V307.65",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7244 273.02H108.341V308.474H92.7244V273.02Z",
    fill: "#1E5DEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.533 233.198V314.742",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.429 299.256H87.0454V334.709H71.429V299.256Z",
    fill: "#1E5DEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2378 259.433V340.977",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242.162 199.431H258.575V214.862H242.162V199.431Z",
    fill: "#1E5DEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M249.598 193.489V227.525",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M199.2 222.03H214.816V239.047H199.2V222.03Z",
    fill: "#1E5DEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M207.008 184.98V277.16",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M348.363 214.862H364.775V222.578H348.363V214.862Z",
    fill: "#1E5DEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M356.073 124V243.125",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M390.855 187.699H406.471V190.535H390.855V187.699Z",
    fill: "#1E5DEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M398.664 188.408V250.924",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M263.085 175.849H278.701V183.881H263.085V175.849Z",
    fill: "#1E5DEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M270.894 177.856V216.181",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.969 218.16H342.585V225.25H326.969V218.16Z",
    fill: "#1E5DEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M334.778 213.698V265.165",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.905 234.91H193.521V242H177.905V234.91Z",
    fill: "#1E5DEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.713 246.463V194.996",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M305.675 218.16H321.291V245.105H305.675V218.16Z",
    fill: "#1E5DEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M313.483 213.698V243.125",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M284.38 202.915H299.996V220.73H284.38V202.915Z",
    fill: "#1E5DEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M292.188 198.453V218.75",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M412.083 195.573H428.496V203.289H412.083V195.573Z",
    fill: "#1E5DEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M419.958 187.699V213.698",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M432.357 188.823H448.77V210.04H432.357V188.823Z",
    fill: "#1E5DEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M441.252 155.081V297.015",
    stroke: "#1E5DEB",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluew);
export default __webpack_public_path__ + "static/media/bluew.62ce15021d8fa4ef94d9df7ee70183ff.svg";
export { ForwardRef as ReactComponent };